import { WBGT_SCALE } from '../wbgt/wbgtScale.js';
import { TEMP_BANDS } from '../../lib/tempColor.js';
import type { MapMode } from './types.js';

export function Legend({ mode }: { mode: MapMode }) {
  return (
    <div className="pointer-events-none absolute left-3 top-3 rounded-md bg-white/90 px-3 py-2 text-xs shadow-md backdrop-blur">
      {mode === 'wbgt' ? <WbgtLegend /> : <ForecastLegend />}
    </div>
  );
}

function WbgtLegend() {
  return (
    <>
      <p className="font-semibold text-slate-700">暑さ指数 WBGT</p>
      <p className="mb-1 text-[9px] leading-tight text-slate-500">予測・近似値</p>
      <ul className="space-y-0.5">
        {WBGT_SCALE.map((band) => (
          <li key={band.level} className="flex items-center gap-2">
            <span
              className="inline-block h-3 w-3 rounded-sm"
              style={{ backgroundColor: band.color }}
              aria-hidden
            />
            <span className="text-slate-700">{band.label}</span>
            <span className="ml-auto pl-2 text-slate-400">
              {band.min === -Infinity ? '〜' : band.min}
              {band.max === Infinity ? '+' : `–${band.max}`}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
}

function ForecastLegend() {
  return (
    <>
      <p className="mb-1 font-semibold text-slate-700">最高気温 (°C)</p>
      <ul className="space-y-0.5">
        {TEMP_BANDS.map((band) => (
          <li key={band.label} className="flex items-center gap-2">
            <span
              className="inline-block h-3 w-3 rounded-sm"
              style={{ backgroundColor: band.color }}
              aria-hidden
            />
            <span className="text-slate-700">{band.label}</span>
            <span className="ml-auto pl-2 text-slate-400">
              {band.min === -Infinity ? '〜' : band.min}
              {band.max === Infinity ? '+' : `–${band.max}`}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
}
